export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/forte-icon.svg?ef1c62d5b5ee456feeda9c3a899fd091";